import { Stripe } from '@stripe/stripe-js';

/**
 * Stripe state - Plain data structure only
 * Follows established Vuex pattern: state contains only plain data
 * Initialization logic moved to actions for lazy loading
 */
export interface StripeState {
  stripe: Stripe | null;
  stripePromise: Promise<Stripe | null> | null;
  isLoading: boolean;
  error: string | null;
}

const state: StripeState = {
  stripe: null,
  stripePromise: null,
  isLoading: false,
  error: null
};

export default state;
